module.exports = __webpack_public_path__ + "media/images/admin/icons/plus_add-fcc3ad83aa064789c1694d8ee7e1a4eb.png";